import { formatMoney } from "../lib/currency";

export default function FXDetails({ transaction: tx }) {
  const foreign = tx?.is_foreign_currency || (tx?.original_currency && (tx.original_currency !== tx.currency || (tx.credit_card_currency && tx.original_currency !== tx.credit_card_currency)));
  if (!foreign) return null;
  return <details className="text-xs mt-1 text-slate-600 dark:text-slate-300" onClick={event => event.stopPropagation()}>
    <summary className="cursor-pointer"><span className="inline-flex rounded-full bg-indigo-50 text-indigo-700 px-2 py-1">🌐 {tx.linked_type === "card_payment" ? "Pago" : "Movimiento"} en {tx.original_currency}</span></summary>
    <div className="space-y-1 py-2">
      <p>Original: {tx.original_currency} {formatMoney(tx.original_amount, tx.original_currency, { style: "decimal" })}</p>
      {tx.credit_card_currency && <p>Tarjeta: {tx.credit_card_currency} {formatMoney(tx.credit_card_amount, tx.credit_card_currency, { style: "decimal" })}</p>}
      <p>Portal: {tx.currency} {formatMoney(Math.abs(tx.amount), tx.currency, { style: "decimal" })}</p>
      {(tx.fx_quotes || []).filter(q => q.base !== q.quote).map((q, i) => <p key={i}>1 {q.base} = {q.rate} {q.quote} · {q.date} · {q.source}</p>)}
      {tx.card_adjusted_at && <p>Cargo corregido según el banco. Cargo inicial: {tx.credit_card_currency} {tx.initial_card_amount}</p>}
    </div>
  </details>;
}
